<template>
  <div class="container activities-container">
    <div class="row mb-3 header">
      <div class="col-lg-8 col-12">
        <h2 class="title">{{ title }} ACTIVITEITEN</h2>
      </div>
      <div class="col-lg-4 col-12">
        <div class="btn-toolbar justify-content-between flex-nowrap" role="toolbar">
          <div class="input-group flex-grow-1">
            <input type="text" v-model="searchQuery" class="form-control" placeholder="... zoeken"
                   aria-label="Recipient's username" aria-describedby="basic-addon2">
            <div class="input-group-append">
              <button class="btn btn-search" type="button" @click="search"><i class="fas fa-search"></i></button>
            </div>
          </div>
          <div class="btn-group">
            <ActivityFilter @filter-updated="onFilterUpdated"></ActivityFilter>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-center" v-if="fetchingQuests">
        <div class="alert alert-primary" role="alert">
          Activiteiten ophalen.
        </div>
        <div class="d-flex justify-content-center">
          <div class="spinner-border" role="status">
            <span class="sr-only">Laden...</span>
          </div>
        </div>
      </div>
      <div class="col-12 text-center" v-else-if="quests.length === 0">
        <h3>Geen activiteiten gevonden.</h3>
      </div>
      <div class="col-12 activities" v-else>
        <QuestSmall :key="quest.id" v-for="quest in quests" :interactable="true" :styleType="'student-platform'"
                    :quest="quest" @clicked="questClicked"></QuestSmall>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <Pagination :item-count="listInfo.totalElements" :items-per-page="itemsPerPage"></Pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { BuddyApi, QuestTypeEnum } from "sandpiper_api";
import log from "@/utils/logger";

import QuestSmall from "@/components/Quests/QuestSmall";
import Pagination from "@/components/UI/Pagination";
import ActivityFilter from "@/components/StudentPlatform/Activities/ActivityFilter";

export default {
  name: "ActivityList",
  components: {Pagination, QuestSmall, ActivityFilter},
  props: {
    title: String,
    selectedBuddy: Object,
    questType: String,
    currentActivities: Array,
    open: Boolean,
  },
  inject: [ 'doApiRequest' ],
  data()
  {
    return {
      fetchingQuests: false,
      quests: [],
      searchQuery: '',
      filterData: null,
      filterIsEmpty: true,


      page: 1,
      listInfo: {},

      questTypeEnum: new QuestTypeEnum(),
    }
  },
  computed: {
    itemsPerPage()
    {
      return 27;
    },
    showQuestImpulse()
    {
      // We would have to create our own PageRequest implementation where we can pass through the offset ourselves,
      // because currently we would be losing item number 30 in this setup.
      // return this.filterIsEmpty && this.page === 1;
      return this.filterIsEmpty;
    }
  },
  methods: {
    fetchQueryParams()
    {
      this.page = parseInt(this.$route.query.page) || 1;
      this.searchQuery = this.$route.query.search || '';
    },
    onFilterUpdated(filterData, isEmpty)
    {

      log.debug("Filter updated");
      this.filterData = filterData;
      this.filterIsEmpty = isEmpty;


      let params = { ...this.$route.query };
      if (params.page && params.page > 1)
      {
        delete params.page;
        this.$router.push({ path: this.$route.path, query: params });
      }
      else
      {
        this.fetchQuestsForBuddy();
      }
    },
    async fetchQuestsForBuddy()
    {

      if (!this.selectedBuddy || this.fetchingQuests) return;

      try
      {
        this.fetchingQuests = true;

        this.quests = [];

        let params = {
          count: this.itemsPerPage,
          page: this.page - 1,
          questSearchQuery: this.searchQuery
        };

        //force filter on chosen questType
        if (this.filterData !== null)
        {
          this.filterData.questType = [ this.questType ];
        }
        else
        {
          this.filterData = {
            questType: [ this.questType ]
          }
        }

        params = Object.assign(params, this.filterData);

        log.debug("List quest params: %o", params);

        const response = await this.doApiRequest(() => new BuddyApi().getQuestsForBuddy(this.selectedBuddy.id, params));

        this.quests = this.filterOutCurrentlyActiveQuests(response.quests);
        this.listInfo = {
          currentPage: response.currentPage,
          numberOfElements: response.numberOfElements,
          totalPages: response.totalPages,
          totalElements: response.totalElements
        };
      }
      catch (e)
      {
        // TODO - handle error
      }
      finally
      {
        this.fetchingQuests = false;
      }
    },

    filterOutCurrentlyActiveQuests(quests)
    {
      let filteredQuests = quests;
      return filteredQuests;
    },

    search()
    {
      let params = { ...this.$route.query };
      params.search = this.searchQuery;

      this.$router.push({ path: this.$route.path, query: params });
    },
    loadQuestImpulseDetails()
    {
      this.$router.push({
        name: "quest-detailed-grouped", params: {
          questType: this.questTypeEnum.impulse
        },
        query: {
          buddyId: this.selectedBuddy.id
        }
      });
    },
    questClicked(id)
    {
      this.$emit("questClicked", id);
    }
  },
  watch: {
    $route(to, from)
    {
      // We're only watching for param changes on the same page, ignore if we're going to a different page/component
      if (from.name === to.name)
      {
        log.debug("Route watch trigger:\nFrom: %o\nTo: %o", from, to);
        this.fetchQueryParams();
        this.fetchQuestsForBuddy();
      }
    },
    selectedBuddy(newValue, oldValue)
    {
      log.info("Selected buddy was updated\nfrom: %o\nto: %o", oldValue, newValue);
      if (newValue !== oldValue)
      {
        this.fetchQuestsForBuddy();
      }
    },
    open()
    {
      let query = Object.assign({}, this.$route.query);
      delete query.search;
      delete query.page;
      this.$router.replace({ query });
      this.searchQuery = "";
      this.filterData = null;
    },
    questType(newValue, oldValue)
    {
      if (newValue !== oldValue)
      {
        this.fetchQuestsForBuddy();
      }
    }
  },
  created()
  {
    this.fetchQueryParams();
  }
}
</script>

<style lang="scss" scoped>

.container {
  padding: 21px;
}

.activities {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-auto-rows: 50px;
  grid-gap: 10px 25px;
}

.activities-container {
  overflow: auto;
  max-height: 90%;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;

  .title {
    font-size: 1.5rem;
    font-weight: bold;
    margin-bottom: 0.3rem;
    color: white;

  }
}

.btn-toolbar {
  gap: 1rem;

  .btn-search, .btn-filter {
    background-color: $primary-blue;
    color: $font-light;
  }
}
</style>